var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutPlus2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_165)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 19C12.6667 15.5022 15.5023 12.6667 19.0001 12.6667H57.0001C60.498 12.6667 63.3334 15.5022 63.3334 19V44.3333C63.3334 47.8312 60.498 50.6667 57.0001 50.6667H38.6559C38.236 50.6667 37.8332 50.8336 37.5365 51.1303L28.0363 60.6303C27.0389 61.6278 25.3334 60.9213 25.3334 59.5108V52.25C25.3334 51.3757 24.6245 50.6667 23.7501 50.6667H19.0001C15.5023 50.6667 12.6667 47.8312 12.6667 44.3333V19Z",
    stroke: "#8161EB",
    strokeWidth: 6.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 25.3333H50.6666",
    stroke: "#8161EB",
    strokeWidth: 6.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 38H34.8333",
    stroke: "#8161EB",
    strokeWidth: 6.33333,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPlus2);
export default __webpack_public_path__ + "static/media/about-plus-2.41b8dc72d8b8a5a1ea09853ca6ed9b85.svg";
export { ForwardRef as ReactComponent };